export default __webpack_public_path__ + "static/media/logo-finish.605c3d4a.png";